import ConsolidatedRequests from "app/api/consolidated";
import { handleGenericApiError } from "app/api/error";

export const ACTION_SAVE_APPROVED_SIMULATION =
  "consolidated:ACTION_SAVE_APPROVED_SIMULATION";
export const ACTION_LOADING_APPROVED_SIMULATION =
  "consolidated:ACTION_LOADING_APPROVED_SIMULATION";

export const ACTION_SAVE_SIMULATION = "consolidated:ACTION_SAVE_SIMULATION";
export const ACTION_LOADING_SIMULATION =
  "consolidated:ACTION_LOADING_SIMULATION";

export const ACTION_SAVE_CLIENT = "consolidated:ACTION_SAVE_CLIENT";
export const ACTION_LOADING_CLIENT = "consolidated:ACTION_LOADING_CLIENT";

export const ACTION_SAVE_ACCESS = "consolidated:ACTION_SAVE_ACCESS";
export const ACTION_LOADING_SAVE_ACCESS =
  "consolidated:ACTION_LOADING_SAVE_ACCESS";

export const ACTION_SAVE_CONTRACT = "consolidated:ACTION_SAVE_CONTRACT";
export const ACTION_LOADING_SAVE_CONTRACT =
  "consolidated:ACTION_LOADING_SAVE_CONTRACT";

export const ACTION_SAVE_HASH = "consolidated:ACTION_SAVE_HASH";
export const ACTION_LOADING_SAVE_HASH = "consolidated:ACTION_LOADING_SAVE_HASH";

export const ACTION_LOADING_TOTAL_CONTRACTS =
  "consolidated:ACTION_LOADING_TOTAL_CONTRACTS";
export const ACTION_SAVE_TOTAL_CONTRACTS_DATA =
  "consolidated:ACTION_SAVE_TOTAL_CONTRACTS_DATA";

export const ACTION_LOADING_INSURANCE_CONTRACTS =
  "consolidated:ACTION_LOADING_INSURANCE_CONTRACTS";
export const ACTION_SAVE_INSURANCE_CONTRACTS_DATA =
  "consolidated:ACTION_SAVE_INSURANCE_CONTRACTS_DATA";

export const fetchConsolidatedApprovedSimulation = params => async dispatch => {
  dispatch({ type: ACTION_LOADING_APPROVED_SIMULATION, payload: true });
  try {
    const data = await ConsolidatedRequests.fetchSimulation(params);
    dispatch({ type: ACTION_SAVE_APPROVED_SIMULATION, payload: data });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch({ type: ACTION_LOADING_APPROVED_SIMULATION, payload: false });
  }
};

export const fetchConsolidated = params => async dispatch => {
  dispatch({ type: ACTION_LOADING_SIMULATION, payload: true });
  try {
    const data = await ConsolidatedRequests.fetchSimulation(params);
    dispatch({ type: ACTION_SAVE_SIMULATION, payload: data });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch({ type: ACTION_LOADING_SIMULATION, payload: false });
  }
};

export const fetchClientConsolidated = params => async dispatch => {
  dispatch({ type: ACTION_LOADING_CLIENT, payload: true });
  try {
    const data = await ConsolidatedRequests.fetchClient(params);
    dispatch({ type: ACTION_SAVE_CLIENT, payload: data });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch({ type: ACTION_LOADING_CLIENT, payload: false });
  }
};

export const fetchAccessConsolidated = params => async dispatch => {
  dispatch({ type: ACTION_LOADING_SAVE_ACCESS, payload: true });
  try {
    const data = await ConsolidatedRequests.fetchAccess(params);
    dispatch({ type: ACTION_SAVE_ACCESS, payload: data });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch({ type: ACTION_LOADING_SAVE_ACCESS, payload: false });
  }
};

export const fetchContractConsolidated = params => async dispatch => {
  dispatch({ type: ACTION_LOADING_SAVE_CONTRACT, payload: true });
  try {
    const data = await ConsolidatedRequests.fetchContract(params);
    dispatch({ type: ACTION_SAVE_CONTRACT, payload: data });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch({ type: ACTION_LOADING_SAVE_CONTRACT, payload: false });
  }
};

export const fetchHashConsolidated = params => async dispatch => {
  dispatch({ type: ACTION_LOADING_SAVE_HASH, payload: true });
  try {
    const data = await ConsolidatedRequests.fetchHash(params);
    dispatch({ type: ACTION_SAVE_HASH, payload: data });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch({ type: ACTION_LOADING_SAVE_HASH, payload: false });
  }
};

export const fetchTotalContracts = bankId => async dispatch => {
  dispatch({ type: ACTION_LOADING_TOTAL_CONTRACTS, payload: true });
  try {
    const data = await ConsolidatedRequests.fetchTotalContracts(bankId);
    dispatch({ type: ACTION_SAVE_TOTAL_CONTRACTS_DATA, payload: data });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch({ type: ACTION_LOADING_TOTAL_CONTRACTS, payload: false });
  }
};

export const fetchInsuranceContracts = codCompany => async dispatch => {
  dispatch({ type: ACTION_LOADING_INSURANCE_CONTRACTS, payload: true });
  try {
    const data = await ConsolidatedRequests.fetchInsuranceContracts(codCompany);
    dispatch({ type: ACTION_SAVE_INSURANCE_CONTRACTS_DATA, payload: data });
  } catch (err) {
    handleGenericApiError(err);
  } finally {
    dispatch({ type: ACTION_LOADING_INSURANCE_CONTRACTS, payload: false });
  }
};
